module.exports = __webpack_public_path__ + "static/media/font.e408e327.svg";